import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {
  testimonials = [
    {
      name: "Shubham Yadav",
      designation: "Interior Designer, Quick Solutions",
      feedback: "Afterbricks has transformed my workflow! ",
      subfeedback:"The free samples are top-notch and the quick delivery lets me make faster decisions. It's a game-changer for my interior projects.",
      image: "https://res.cloudinary.com/afterbricks/image/upload/v1739336572/shubham-yadev_z4yrbo.webp",
      value:5
    },
    {
      name: "Sanjeev Jain",
      designation: "CEO & Chief Designer, Deliadesignarc",
      feedback: "Great service introduced by Afterbricks,",
      subfeedback:"looking forward to avail more of it in the future.",
      image: "https://res.cloudinary.com/afterbricks/image/upload/v1739292749/sanjeev-jain_ntjtkp.webp",
      value:5
    },
    {
      name: "Yash Singh",
      designation: "Interior Designer, Balaji Furniture & Interior",
      feedback: "Afterbricks is my go-to for interior materials.",
      subfeedback:"The free samples are a lifesaver, helping me visualize designs better and make confident choices.",
      image: "https://s3-afterbricks.s3.amazonaws.com/media/profile_image/cropped-image_zFPuAAn.webp",
      value:5
    },
    {
      name: "kartik Gupta",
      designation: "Principal Architect, studio kai",
      feedback: "I love how Afterbricks simplifies material selection.",
      subfeedback:"The variety of samples saves me hours of research, and the quality always impresses my clients.",
      image: "https://s3-afterbricks.s3.amazonaws.com/media/profile_image/Untitled_250__250px_150__150px_90__90px_250__250px_pmN4hLk.jpg",
      value:5
    }
  ];
  owlTestimonial = {
    dots: true,
    loop: true,
    nav: true,
    autoWidth: false,
    margin: 15,
    items: 1,
    lazyLoad: true,
    touchDrag: true,
    autoplay: true,
    autoplayTimeout: 5000,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    navSpeed: 300,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 2 }
    },
    navText: [
      '<i class="fa fa-angle-left arrolefts"></i>',
      '<i class="fa fa-angle-right arrorights"></i>'
    ]
  };

  ngOnInit(): void {
    console.log("")
  }

}
